import { useState } from "react";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/src/components/ui/collapsible";
import { Element } from "@craftjs/core";
import { Text } from "@/src/components/Text";
import { FlexBox } from "@/src/components/FlexBox";
import { WebShopIcon } from "../WebShopIcon";
import { cn } from "@/src/shared/utils/mergeTwClasses";

export function Collapses(props: any) {
  const [open, setOpen] = useState(false);

  const { titleOpen, titleClose, ...restProps } = props;

  return (
    <Collapsible {...restProps} open={open} onOpenChange={setOpen}>
      <CollapsibleTrigger>
        <FlexBox
          id="collapsible-trigger"
          className={
            "items-center justify-center gap-2 font-semibold uppercase"
          }
          style={{ padding: "0" }}
        >
          <Text
            text={open ? titleClose : titleOpen}
            background={"rgb(0,157,222)"}
          ></Text>
          <WebShopIcon
            name={"arrowDown"}
            className={cn(
              "mb-2 h-5 w-5 shrink-0 transition-transform duration-200 [&_path]:fill-[#009dd3]",
              open && "rotate-180",
            )}
          />
        </FlexBox>
      </CollapsibleTrigger>
      <CollapsibleContent>
        <Element
          is={FlexBox}
          canvas
          id={"collapsible-content"}
          direction={"column"}
          style={{
            padding: "0",
            flexDirection: "column",
          }}
        >
          {props.children}
        </Element>
      </CollapsibleContent>
    </Collapsible>
  );
}
